<span #editor
      class="text"
      spellcheck="false"
      [attr.contenteditable]="editing"
      [textContent]="value.caption"
      (blur)="onBlur()"
      (keydown)="onKeydown($event)"
      data-ideals="chip-text">
  {{value.caption}}
</span>
<button class="remove-button icons icons-cross"
        aria-label="Close"
        *ngIf="!editing"
        (click)="onRemove()"
        data-ideals="chip-close-button">
</button>

